<template>
    <div>
        <CoverageMap />
        <v-row class="mt-6">
            <!-- Download ENC -->
            <v-col cols="6">
                <NavCard
                    subTitle="Download the weekly PRIMAR CD content"
                    title="PRIMAR CD Service"
                    icon="mdi-download"
                    _blank
                    linkTo="https://primar.ecc.no/primar/portal/public/enc/downloadEnc.jsf"
                />
            </v-col>

            <v-col cols="6">
                <NavCard
                    _blank
                    linkTo="https://primar.ecc.no/primar/"
                    outlined
                    subTitle="Go to the ENC distribution centre"
                    title="PRIMAR Portal"
                    icon="mdi-earth"
                />
            </v-col>
        </v-row>

        <v-row class="mt-6">
            <!-- Download S-128 -->
            <v-col cols="6">
                <v-card
                    hover
                    color="primary"
                    dark
                    class="pa-4"
                    elevation="5"
                    @click="downloadS128"
                    style="cursor: pointer; height: 100%; width: 100%;"
                >
                    <v-list-item two-line style="height: 100%">
                        <v-list-item-avatar>
                            <v-icon color="secondary" large>{{ s128Icon }}</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title class="text-wrap">{{ s128Title }}</v-list-item-title>
                            <v-list-item-subtitle class="text-wrap">{{ s128SubTitle }}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import NavCard from '@/components/home/NavCard'
import CoverageMap from '@/components/CoverageMap'

export default {
    name: 'Coverage',

    components: {
        NavCard,
        CoverageMap
    },

    metaInfo: {
        title: 'Coverage'
    },

    data() {
        return {
            s128Title: 'Download S-128',
            s128SubTitle: 'Download the S-128 dataset containing all S-100 products in the PRIMAR database',
            s128Icon: 'mdi-download'
        }
    },

    methods: {
        async downloadS128() {
    this.s128Icon = 'mdi-refresh'
    const url = 'https://primar.ecc.no/primar/api/rest/catalogue-s128/createCatalogueZIP/S101,S102,S104,S111';
    this.s128SubTitle = 'Your data is being prepeared... Please wait'
    const filename = '12800PM.zip';
    try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);                
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        
        window.URL.revokeObjectURL(blobUrl);
        document.body.removeChild(a);
        this.s128Icon = 'mdi-download'
        this.s128SubTitle = 'Dataset downloaded!'
    } catch (error) {
        // Fallback to iframe
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = url;
        document.body.appendChild(iframe);
        setTimeout(() => document.body.removeChild(iframe), 2000);
    }
}
    }
}
</script>

<style lang="scss" scoped>
/* Add text-wrap styles if not globally defined; adjust as needed to match your app's text-wrap class */
.text-wrap {
  white-space: normal !important;
  word-break: break-word;
}
</style>